import {HStack, Text} from 'platform/foundation';
import {DateTimeFormat, useDateTimeFormatter} from 'platform/locale';
import {match} from 'ts-pattern';

import {parseDate, type RequiredTestIdProps} from 'shared/web';

interface CustomerInsightsDateMetadataProps extends RequiredTestIdProps {
  occurredAt: string;
}

export function CustomerInsightsDateMetadata(props: CustomerInsightsDateMetadataProps) {
  const formatDateTime = useDateTimeFormatter();
  const date = parseDate(props.occurredAt);

  return match(date)
    .when(
      (parsedDate): parsedDate is Date =>
        parsedDate !== null && !Number.isNaN(parsedDate.getTime()),
      (validDate) => (
        <HStack
          spacing={1}
          align="center"
          minWidth={0}
          data-testid={`${props['data-testid']}-dateMetadata`}
        >
          <Text
            size="xSmall"
            alternative
            noWrap
            data-testid={`${props['data-testid']}-relativeDate`}
          >
            {formatDateTime('dateRelative', validDate)}
          </Text>
          <Text size="xSmall" color="secondary" noWrap>
            <span data-testid={`${props['data-testid']}-absoluteDate`}>
              · <DateTimeFormat format="dateShort" value={validDate} />
            </span>
          </Text>
        </HStack>
      )
    )
    .otherwise(() => null);
}
